module.exports = __webpack_public_path__ + "static/media/create-post.409e9231.svg";